import React from 'react';
import { TextInput as PaperTextInput } from 'react-native-paper';
import { RADIUS } from '../../assets/theme';
import { useAppTheme } from '../../theme/ThemeContext';

type PaperTextInputProps = React.ComponentProps<typeof PaperTextInput>;

/**
 * Paper TextInput with the app defaults: outlined, 12px radius, themed surface.
 * Drop-in replacement: `TextInput.Icon` / `TextInput.Affix` keep working.
 */
function AppTextInput({ mode = 'outlined', outlineStyle, style, ...props }: PaperTextInputProps) {
  const { colors } = useAppTheme();
  return (
    <PaperTextInput
      mode={mode}
      outlineStyle={[{ borderRadius: RADIUS.md }, outlineStyle]}
      outlineColor={colors.border}
      activeOutlineColor={colors.ink}
      style={[{ backgroundColor: colors.surface }, style]}
      {...props}
    />
  );
}

const TextInput = Object.assign(AppTextInput, {
  Icon: PaperTextInput.Icon,
  Affix: PaperTextInput.Affix,
});

export default TextInput;
